import { CalendarComponent, calendarTemplate } from './Calendar';
import styles from './Calendar.styles.scss';
import { withStylePrefix } from '../common/withStylePrefix';
export const chameleonCalendar = CalendarComponent.compose({
    baseName: 'calendar',
    template: calendarTemplate,
    styles: withStylePrefix(styles),
    shadowOptions: {
        delegatesFocus: true,
    },
});
